import { cronJobUtil } from './cronJobList/index';

export const cron = {
  namespaced: true,
  modules: {
    cronJobUtil,
  },
};

export default cron;
